export default "__VITE_ASSET__CGGFM4P6__"